<div>
    <minster-portal-progress [form]="mainForm" [readOnly]="_readonly" />
</div>

<form #mainForm="ngForm" (ngSubmit)="onSubmit(mainForm)">
    <app-personal [hidden]="_currentScreen !== _screenTypes.Personal" />
    <app-employment  [hidden]="_currentScreen !== _screenTypes.Employment" />
    <app-your-accident-your-involvement [hidden]="_currentScreen !== _screenTypes.YourAccidentYourInvolvement" />
    <app-your-accident-time-location [hidden]="_currentScreen !== _screenTypes.YourAccidentTimeLocation" />
    <app-your-accident-description [hidden]="_currentScreen !== _screenTypes.YourAccidentDescription" />
    <app-your-injuries-details  [hidden]="_currentScreen !== _screenTypes.YourInjuriesDetails" />
    <app-your-injuries-medical-attention [hidden]="_currentScreen !== _screenTypes.YourInjuriesMedicalAttention" />
    <app-your-vehicle [hidden]="_currentScreen !== _screenTypes.YourVehicle" />
    <app-responsible-party [hidden]="_currentScreen !== _screenTypes.ResponsibleParty" />
    <app-police-and-witnesses [hidden]="_currentScreen !== _screenTypes.PoliceAndWitnesses" />
    <app-passengers [hidden]="_currentScreen !== _screenTypes.Passengers" />
    <app-submit [hidden]="_currentScreen !== _screenTypes.Summary" [screenValidation]="_screenValidation"></app-submit>
    <button #submitButton type="submit" id="submitButton">Submit form</button>

     @if (_currentScreen === _screenTypes.Summary) {
         <div class="back-next">
            <button mat-raised-button type="button" class="secondary-button" (click)="onPrev()">Back</button>
            @if(!_readonly){
                <button mat-raised-button type="button" color="accent" (click)="showStatementOfTruth()">Confirm</button>
            }            
        </div>
    }
</form>

